// extracted by mini-css-extract-plugin
export default {"box":"BadgesProjects_box__o83nW","tipo":"BadgesProjects_tipo__hK-3y"};